import {throwIfUndefined} from '@coolcolduk/util';
import {JournalSession, mapJournalSessionDbToType, type JournalSessionDb} from '@cp/model';
import {useLayoutEffect} from 'react';
import {JOURNAL_SESSIONS_PAGE_SIZE, listJournalSessionsQuery} from '../../api/journalSession/listJournalSessions';
import {FirestoreCursor} from '../../types/FirestoreCursor';
import useFunctionPagination from '../helper/function/useFunctionPagination';
import {useAuth} from '../users/useAuth';

export default function useJournalSessions() {
  const user = useAuth();
  const uid = user?.id;

  const pagination = useFunctionPagination<JournalSession, JournalSessionDb>(
    (cursor: FirestoreCursor) =>
      listJournalSessionsQuery(uid || '', JOURNAL_SESSIONS_PAGE_SIZE, cursor).then((snapshot) => snapshot.docs),
    mapJournalSessionDbToType,
    {
      skip: uid === undefined,
      countFn: () => listJournalSessionsQuery(throwIfUndefined(uid), undefined).then((snapshot) => snapshot.size),
    },
  );

  useLayoutEffect(() => {
    if (uid === undefined) {
      pagination.clearData();
    }
  }, [uid, pagination.clearData]);

  return pagination;
}
